module.exports = __webpack_public_path__ + "img/Header_My_Right.b1cbc724.svg";